import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d2013466&"
var script = {}
import style0 from "./generic-styles/global.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports